// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_h3-3";
export var flatBottomCorners = "_h3-5";
export var productImage = "_h3-0";
export var quantityContainer = "_h3-2";
export var quantityHeader = "_h3-6";
export var tooltip = "_h3-1";
export var wrapAndEllipsesOverflow = "_h3-4";